import { __rest } from "tslib";
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
const PlayFilled = (_a) => {
    var { size } = _a, props = __rest(_a, ["size"]);
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M8.26582096,6.80664662 L16.1774936,11.1221044 C16.6623419,11.3865672 16.8409998,11.9940038 16.5765371,12.4788521 C16.4845917,12.6474186 16.3460601,12.7859502 16.1774936,12.8778956 L8.26582096,17.1933534 C7.78097262,17.4578161 7.17353598,17.2791583 6.90907325,16.7943099 C6.8289522,16.6474213 6.78696883,16.4827768 6.78696883,16.3154578 L6.78696883,7.68454219 C6.78696883,7.13225744 7.23468408,6.68454219 7.78696883,6.68454219 C7.95428782,6.68454219 8.11893236,6.72652556 8.26582096,6.80664662 Z" })));
};
PlayFilled.displayName = 'PlayFilled';
export default PlayFilled;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=PlayFilled.js.map